/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeGoCampaign_PoliticalDistricts.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Political District Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Wednesday, July 10, 2019 - 12:15:48 AM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      07/10/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const POLITICALDISTRICT_LIST_CONTAINER_LOADED = 'POLITICALDISTRICT_LIST_CONTAINER_LOADED';
export const POLITICALDISTRICT_LIST_CONTAINER_UNLOADED = 'POLITICALDISTRICT_LIST_CONTAINER_UNLOADED';
export const POLITICALDISTRICT_LIST_TABLE_LOADED = 'POLITICALDISTRICT_LIST_TABLE_LOADED';
export const POLITICALDISTRICT_LIST_TABLE_UNLOADED = 'POLITICALDISTRICT_LIST_TABLE_UNLOADED';

export const POLITICALDISTRICT_LIST_CHANGE_GROUP = 'POLITICALDISTRICT_LIST_CHANGE_GROUP';
export const POLITICALDISTRICT_SELECT_ROW = 'POLITICALDISTRICT_SELECT_ROW';

export const POLITICALDISTRICT_ADD = 'POLITICALDISTRICT_ADD';
export const POLITICALDISTRICT_EDIT = 'POLITICALDISTRICT_EDIT';
export const POLITICALDISTRICT_DELETE = 'POLITICALDISTRICT_DELETE';
export const POLITICALDISTRICT_OPEN_WARNING = 'POLITICALDISTRICT_OPEN_WARNING';
export const POLITICALDISTRICT_CLOSE_WARNING = 'POLITICALDISTRICT_CLOSE_WARNING';
export const POLITICALDISTRICT_DELETE_DISABLE = 'POLITICALDISTRICT_DELETE_DISABLE';
export const POLITICALDISTRICT_VIEW_CHILD_ITEMS = 'POLITICALDISTRICT_VIEW_CHILD_ITEMS';

export const POLITICALDISTRICT_EDIT_CONTAINER_LOADED = 'POLITICALDISTRICT_EDIT_CONTAINER_LOADED';
export const POLITICALDISTRICT_EDIT_CONTAINER_UNLOADED = 'POLITICALDISTRICT_EDIT_CONTAINER_UNLOADED';
export const POLITICALDISTRICT_EDIT_FORM_LOADED = 'POLITICALDISTRICT_EDIT_FORM_LOADED';
export const POLITICALDISTRICT_EDIT_FORM_UNLOADED = 'POLITICALDISTRICT_EDIT_FORM_UNLOADED';

export const POLITICALDISTRICT_SET_GROUP_SELECT = 'POLITICALDISTRICT_SET_GROUP_SELECT';
export const POLITICALDISTRICT_EDIT_DATA_LOAD = 'POLITICALDISTRICT_EDIT_DATA_LOAD';

export const POLITICALDISTRICT_EDIT_CONTAINER_SUBMIT = 'POLITICALDISTRICT_EDIT_CONTAINER_SUBMIT';
export const POLITICALDISTRICT_EDIT_CONTAINER_CANCEL = 'POLITICALDISTRICT_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeGoCampaign_PoliticalDistricts.js